import { useEffect, useRef } from "react";
import { useToast } from "../hooks/use-toast";
import { ticketsAPI, internalChatAPI } from "../services/api";
import { useAuth } from "../contexts/AuthContext";

export const NotificationSystem = () => {
  const { toast } = useToast();
  const { user } = useAuth();

  const prevPendingRef = useRef(null);
  const prevPotencialRef = useRef(null);
  const prevUnreadRef = useRef(null);
  const prevInternalUnreadRef = useRef(null);
  const userInteracted = useRef(false);

  useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }

    const handleInteraction = () => {
      userInteracted.current = true;
      if ("Notification" in window && Notification.permission === "default") {
        Notification.requestPermission();
      }
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
    };

    window.addEventListener("click", handleInteraction);
    window.addEventListener("keydown", handleInteraction);

    return () => {
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
    };
  }, []);

  useEffect(() => {
    if (!user) return;

    const checkNotifications = async () => {
      try {
        const response = await ticketsAPI.getAll();

        let todosTickets = [];
        if (Array.isArray(response.data)) {
          todosTickets = response.data;
        } else if (response.data && Array.isArray(response.data.items)) {
          todosTickets = response.data.items;
        } else if (response.data && Array.isArray(response.data.tickets)) {
          todosTickets = response.data.tickets;
        }

        const filaCount = todosTickets.filter(t => t.status === "pending" && t.menu_response_received === true).length;
        const potencialCount = todosTickets.filter(t => t.status === "pending" && t.menu_response_received === false).length;
        const meusTickets = todosTickets.filter((t) => t.assigned_to === user.id);
        const unreadCount = meusTickets.reduce((acc, t) => acc + (t.unread_count || 0), 0);

        let totalInternalUnread = 0;
        try {
          const internalRes = await internalChatAPI.getUnreadCounts();
          const countsObj = internalRes.data || {};
          totalInternalUnread = Object.values(countsObj).reduce((acc, count) => acc + count, 0);
        } catch (err) {
          console.error("Erro ao buscar notificações do chat interno", err);
        }

        if (prevPendingRef.current === null) {
          prevPendingRef.current = filaCount;
          prevPotencialRef.current = potencialCount;
          prevUnreadRef.current = unreadCount;
          prevInternalUnreadRef.current = totalInternalUnread;
          return;
        }

        if (filaCount > prevPendingRef.current) {
          if (userInteracted.current) playNewTicketSound();
          /* toast({
            title: "🔔 Novo Atendimento na Fila",
            description: "Um cliente selecionou uma opção no menu e aguarda atendimento.",
            className: "bg-blue-50 border-blue-400 text-blue-800",
          });
          */
          dispararNotificacaoNativa("🔔 Novo Atendimento na Fila!", "Um cliente selecionou uma opção no menu e aguarda atendimento.");
        }

        if (potencialCount > prevPotencialRef.current) {
          if (userInteracted.current) playNewTicketSound();
          /*
          toast({
            title: "🔔 Novo Atendimento em Potencial",
            description: "Um cliente acabou de enviar mensagem, mas ainda não selecionou o menu.",
            className: "bg-orange-50 border-orange-400 text-orange-800",
          });
          */
          dispararNotificacaoNativa("🔔 Novo Atendimento em Potencial!", "Um cliente acabou de enviar mensagem, mas ainda não selecionou o menu.");
        }

        if (unreadCount > prevUnreadRef.current) {
          if (userInteracted.current) playNewMessageSound();
          /*
          toast({
            title: "💬 Nova Mensagem",
            description: "Você tem uma nova mensagem de cliente não lida.",
            className: "bg-green-50 border-green-400 text-green-800",
          });
          */
          dispararNotificacaoNativa("💬 Nova Mensagem", "Você tem uma nova mensagem de cliente não lida.");
        }

        if (totalInternalUnread > prevInternalUnreadRef.current) {
          if (userInteracted.current) playNewMessageSound();
          /*
          toast({
            title: "👥 Chat da Equipe",
            description: "Nova mensagem não lida no chat interno.",
            className: "bg-purple-50 border-purple-400 text-purple-800",
          });
          */
          dispararNotificacaoNativa("👥 Chat da Equipe", "Nova mensagem não lida no chat interno.");
        }

        prevPendingRef.current = filaCount;
        prevPotencialRef.current = potencialCount;
        prevUnreadRef.current = unreadCount;
        prevInternalUnreadRef.current = totalInternalUnread;

      } catch (error) {
        console.error("🚨 Erro no NotificationSystem:", error);
      }
    };

    const interval = setInterval(checkNotifications, 5000);
    return () => clearInterval(interval);
  }, [user, toast]);

  const dispararNotificacaoNativa = (titulo, corpo) => {
    if (!("Notification" in window)) return;

     if (document.visibilityState === "visible") return;

    if (Notification.permission === "granted") {
      const notif = new Notification(titulo, {
        body: corpo,
        icon: "/favicon.ico",
      });

      notif.onclick = function () {
        window.focus();
        this.close();
      };
    }
  };

  const playNewTicketSound = () => {
    const audio = new Audio("/notification.mp3");
    audio.volume = 1.0;
    audio.play().catch(() => {});
  };

  const playNewMessageSound = () => {
    const audio = new Audio("/message-notification.mp3");
    audio.volume = 1.0;
    audio.play().catch(() => {});
  };

  return null;
};